import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
    return (
        <header id="header-section">
            <div class="overlay">
                <div class="container">
                    <div class="row d-flex header-area">
                        <div class="logo-section flex-grow-1 d-flex align-items-center">
                            <Link class="site-logo site-title" to="/">
                                {/* <img src="../../assets/images/logo.png" alt="site-logo" /> */}
                            </Link>
                        </div>
                        <button class="navbar-toggler ml-auto collapsed" type="button" data-toggle="collapse"
                            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                            aria-expanded="false" aria-label="Toggle navigation">
                            <i class="fas fa-bars"></i>
                        </button>
                        <nav class="navbar navbar-expand-lg p-0">
                            <div class="navbar-collapse collapse" id="navbarSupportedContent">
                                <ul class="navbar-nav main-menu ml-auto">
                                    <li><Link to="/">Home</Link></li>
                                    <li class="menu_has_children"><a href="#0">Tournaments</a>
                                        <ul class="sub-menu">
                                            <li><Link to="/tournaments">Tournaments</Link></li>
                                            <li><Link to="/tournamanet-single">Tournaments Single</Link></li>
                                        </ul>
                                    </li>
                                    <li class="menu_has_children"><a href="#0">Pages</a>
                                        <ul class="sub-menu">
                                            <li><Link to="/about">About Us</Link></li>
                                            <li><Link to="/shop">Shop</Link></li>
                                            <li><Link to="/shop-details">Shop Details</Link></li>
                                            <li><Link to="/profile">Profile</Link></li>
                                            <li><Link to="/cart">Cart</Link></li>
                                        </ul>
                                    </li>
                                    <li><Link to="/contact">Contact</Link></li>
                                </ul>
                            </div>
                        </nav>
                        <div class="right-area header-action d-flex align-items-center">
                            <Link to="/login" class="login-btn">Login</Link>
                            <Link to="/registration" class="cmn-btn">Join Now!</Link>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Navbar;